angular
.module('jv.candidate.eval.req.info.controller',[])
.controller('CandDetailsEvalReqMoreInfoModalCtrl', ['$scope', '$routeParams', '$rootScope', '$filter', 'candidates', 'videoService',
function($scope, $routeParams, $rootScope, $filter, candidates, videoService) {
    $scope.isNewJQuery = parseFloat(jQuery.fn.jquery) > 1.7;
    var selectDefaultTemplate = function(templates){
        angular.forEach(templates, function(tpl) {
            if (tpl['default']) {
                $scope.vidTemplates = $scope.vidTemplates || {};
                $scope.vidTemplates.messageTpl = tpl;
                $scope.content = tpl.body;
                $scope.subject = tpl.subject;
            }
        });
        return templates;
    };
    $scope.$on('evalRequestMoreInformationCtrl', function(event, id) {
        $scope.evalItem = id;
        //TODO-PRANAV: Needs to be updated with the new endpoint.
        videoService.evalRequestMoreInformationTemplates({formID: $scope.evalItem.interviewId}, function(res) {
            $scope.vidTemplates = $scope.vidTemplates || {};
            $scope.vidTemplates.messageTemplates = selectDefaultTemplate($scope.select2Options.setTemplates(res.resultList));
            $scope.checkIfReadyToShow();
        });
    });

    $scope.$on('hidingVideoModals', function(e, val) {
        $scope.cleanModal();
    });

    $scope.cleanModal = function() {
        $scope.submitted = false;
        $scope.vidTemplates = {};
        makePristine($scope.evalReqMoreInfoForm, $('form[name="evalReqMoreInfoForm"]'));
    };


    /*
     * TODO-PRANAV: Copying this from jv.ReqsNotesCtrl.js beacuse Candidate Details Page is using
     * Angular 1.0.1 and setPristine is available in 1.1.* onwards. Once we upgrade will not need this code.
     * So dont want to invest time in making code resuable etc. `
     * This function makes the form pristine(setting to initial state of the form).
     */
    var makePristine=function(formCtrl,elem) {
        var name;
        if (formCtrl && formCtrl.$name) {
            name = $filter('uppercase')(formCtrl.$name.charAt(0)) + formCtrl.$name.substr(1);
            if(elem){
                // new version of angular has $setPristine, use when available
                if (formCtrl.$setPristine) {
                    formCtrl.$setPristine();
                }
                else {
                    elem.removeClass('ng-dirty').addClass('ng-pristine');
                    formCtrl.$pristine = true;
                    formCtrl.$dirty = false;
                    angular.forEach(elem.find('.ng-dirty'), function(el) {
                        var inputCtrl = $(el).data('$ngModelController');
                        inputCtrl.$pristine = true;
                        inputCtrl.$dirty = false;
                        $(el).removeClass('ng-dirty').addClass('ng-pristine');
                    });
                }
            }
        }
    };

    $scope.checkIfReadyToShow = function() {
        if ($scope.vidTemplates.messageTemplates) {
            $scope.modal.evalReqMoreInfo = true;
            $scope.flags.loading = false;
        }
    }

    $scope.sendEvalReqMoreInfo = function(form,index){
        var videoForm = {};
        videoForm.subject = $scope.subject;
        videoForm.message = $scope.content;
        videoForm.evalID = $scope.evalItem.interviewId;

        var data = '';
        /* Validation*/
        if ($scope.evalReqMoreInfoForm.$invalid) {
            return;
        }

        /*This is to escape the special characters */
        var formContent = encodeURIComponent(videoForm.content);
        var formSubject = encodeURIComponent(videoForm.subject);

        //TODO-PRANAV
        // $scope.modal.evalReqMoreInfo =false;
        // $scope.cleanModal();
        // $scope.showMsg('Request More Information Sent', true);
        $scope.flags.loading = true;
        videoService.evalRequestMoreInformation(videoForm, function(data) {
            //if (data.status === "ok") {
                $scope.flags.loading = false;
                $scope.modal.evalReqMoreInfo=false;
                $scope.cleanModal();
                $scope.showMsg('DETAILS_REQUESTED');
            //}
        });
    };
}]);